<template>
  <div>
    <UpdateForm :event-id="getEventId"/>
  </div>
</template>

<script>

import UpdateForm from "../components/Form/UpdateForm";
import store from "@/store";
export default {
  name: "EditEventPage",
  components: {UpdateForm},
  async created() {

    if(!store.state.token) {
      window.location.replace('/connexion');
    }

    if(!this.getEventId) {
      window.location.replace('/mes-evenements');
    }

  },
  computed: {
    getEventId() {
      const id = store.state.editingEventID
      if (!id) return null
      return id
    }
  }
}
</script>

<style scoped>

</style>
